// extracted by mini-css-extract-plugin
export default {"headerRow":"ProjectTable_headerRow__6g4VP"};